<template>
  <div class="fixed top-0 left-0" style="z-index: 200">
    <div class="screen pt-42.5 h-screen w-screen fixed" :style="'top:0'">
      <div class="langs px-23.5 flex">
        <div
          class="lang cursor-pointer mr-20"
          :class="{ active: lang === 'ru' }"
          @click="setLang('ru')"
        >
          <p class="uppercase fz-13 font-semibold">русский</p>
          <div class="decorator mt-4.5 h-2px"></div>
        </div>
        <div
          class="lang cursor-pointer mr-20"
          :class="{ active: lang === 'ua' }"
          @click="setLang('ua')"
        >
          <p class="uppercase fz-13 font-semibold">українська</p>
          <div class="decorator mt-4.5 h-2px"></div>
        </div>
        <div
          class="lang cursor-pointer"
          :class="{ active: lang === 'en' }"
          @click="setLang('en')"
        >
          <p class="uppercase fz-13 font-semibold">english</p>
          <div class="decorator mt-4.5 h-2px"></div>
        </div>
      </div>
      <nav class="mt-32.5 px-23.5 flex flex-col gap">
        <div
            @click="setRoute('agency')"
          class="nav-item flex items-center justify-between relative pt-7.5 pb-8.75"
        >
          <div
            class="nav-background absolute top-0 right-0 bottom-0 left-0"
          ></div>
          <h3
            class="relative z-10 font-medium fz-20 uppercase cursor-pointer"
          >
            {{ text.agency }}
          </h3>
          <div class="plus w-5 h-5 relative">
            <div
              class="absolute w-4 h-2px bg-white left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2 rotate-90"
            ></div>
            <div
              class="absolute w-4 h-2px bg-white left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2"
            ></div>
          </div>
        </div>
        <div
            @click="setRoute('projects')"
            class="nav-item flex items-center justify-between relative pt-7.5 pb-8.75"
        >
          <div
            class="nav-background absolute top-0 right-0 bottom-0 left-0"
          ></div>
          <h3
            class="relative z-10 font-medium fz-20 uppercase cursor-pointer"
          >
            {{ text.projects }}
          </h3>
          <div class="plus w-5 h-5 relative">
            <div
              class="absolute w-4 h-2px bg-white left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2 rotate-90"
            ></div>
            <div
              class="absolute w-4 h-2px bg-white left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2"
            ></div>
          </div>
        </div>
        <div
          class="nav-item flex items-center justify-between relative pt-7.5 pb-8.75"
          @click="setRoute('blog')"
        >
          <div
            class="nav-background absolute top-0 right-0 bottom-0 left-0"
          ></div>
          <h3
            class="relative z-10 font-medium fz-20 uppercase cursor-pointer"
          >
            {{ text.blog }}
          </h3>
          <div class="plus w-5 h-5 relative ">
            <div
              class="absolute w-4 h-2px bg-white left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2 rotate-90"
            ></div>
            <div
              class="absolute w-4 h-2px bg-white left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2"
            ></div>
          </div>
        </div>
        <div
            @click="toggleContacts"
          class="nav-item flex items-center justify-between relative pt-7.5 pb-8.75"
        >
          <div
            class="nav-background absolute top-0 right-0 bottom-0 left-0"
          ></div>
          <h3
            class="relative z-10 font-medium fz-20 uppercase cursor-pointer"
          >
            {{ text.contacts }}
          </h3>
          <div class="plus w-5 h-5 relative">
            <div
              class="absolute w-4 h-2px bg-white left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2 rotate-90"
            ></div>
            <div
              class="absolute w-4 h-2px bg-white left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2"
            ></div>
          </div>
        </div>
      </nav>
    </div>
  </div>
</template>

<script>
import {mapMutations, mapState} from "vuex";

export default {
  name: "Menu",
  props: ["slide"],
  methods: {
    ...mapMutations(['toggleContacts', 'setRoute', 'setLang']),
  },
  computed: {
    ...mapState(['page', 'lang']),
    absolute() {
      return (
        this.page !== "post" &&
        this.page !== "project" &&
        this.page !== "blog"
      );
    },
    text() {
      return require("@/assets/text/menu/" + this.lang + ".json");
    },
  },
};
</script>

<style scoped lang="scss">
.screen {
  background: #323749;
  left: 0;
  position: absolute;
}

.menu-enter-active,
.menu-leave-active {
  transition: all 0.3s linear;
}
.menu-enter-from,
.menu-leave-to {
  left: -100vw;
}
.lang {
  p {
    color: rgba(110, 117, 141, 1);
    transition: all linear 0.2s;
  }
  .decorator {
    transition: all linear 0.2s;
    width: 0%;
    background: rgba(255, 46, 83, 1);
  }
}
.lang:hover,
.lang.active {
  p {
    color: white;
  }
  .decorator {
    width: 100%;
  }
}
</style>
